"use strict";require('@ebay/skin/menu-button');
require('./ebay-menu-button.css');